module.exports = __webpack_public_path__ + "static/ionicons-28df6ee7b407fd8a14b40bc01f4fd3ae.svg";